import { render, staticRenderFns } from "./Dotacoes.vue?vue&type=template&id=2383f8eb&scoped=true&"
import script from "./Dotacoes.vue?vue&type=script&lang=js&"
export * from "./Dotacoes.vue?vue&type=script&lang=js&"
import style0 from "./Dotacoes.vue?vue&type=style&index=0&id=2383f8eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2383f8eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VContainer,VRow,VTextField})
